import { useEffect } from "react";

export const GOOGLE_TRAFFIC_SOURCE_KEY = "STOREFRONT_GOOGLE_AD_SOURCE";
export const GOOGLE_CAMPAIGN_ID_KEY = "STOREFRONT_GOOGLE_CAMPAIGN_ID";

export function getStoredGoogleTrafficSource(): "google_ads" | "google_shopping" | null {
  return sessionStorage.getItem(GOOGLE_TRAFFIC_SOURCE_KEY) as "google_ads" | "google_shopping" | null;
}

export function getStoredGoogleCampaignId(): string | null {
  return sessionStorage.getItem(GOOGLE_CAMPAIGN_ID_KEY);
}

// gad_source 파라미터가 있거나 utm_source=google&utm_medium=paid 조합일 때 구글애즈,
// utm_source=google&utm_medium=shopping 조합일 때 구글쇼핑으로 판별.
// 캠페인 id는 utm_campaign이 쇼핑피드 기본값(always_on)이 아니면 그 값을 사용하고, always_on이면 gad_campaignid를 사용한다.
export default function useGoogleTrafficSource(search: string): void {
  useEffect(() => {
    const params = new URLSearchParams(search);
    const utmSource = params.get("utm_source");
    const utmMedium = params.get("utm_medium");

    const isGoogleAds = utmSource === "google" && (params.has("gad_source") || Boolean(utmMedium?.includes("paid")));
    const isGoogleShopping = utmSource === "google" && utmMedium === "shopping";

    if (isGoogleAds) {
      sessionStorage.setItem(GOOGLE_TRAFFIC_SOURCE_KEY, "google_ads");
      const utmCampaign = params.get("utm_campaign");
      const campaignId = utmCampaign && utmCampaign !== "always_on" ? utmCampaign : params.get("gad_campaignid");
      if (campaignId) sessionStorage.setItem(GOOGLE_CAMPAIGN_ID_KEY, campaignId);
    } else if (isGoogleShopping) {
      sessionStorage.setItem(GOOGLE_TRAFFIC_SOURCE_KEY, "google_shopping");
    }
  }, [search]);
}
